import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationComponent } from '../shared/components/confirmation/confirmation.component';
import { IDialog } from '../shared/interfaces/common.interface';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class PopupService {
  constructor(
    private modalService: BsModalService,
    private toastrService: ToastrService,
  ) {}

  // error toast message
  messsageAlert(type: 'error' | 'success' | 'info' | 'warning', text: string) {
    switch (type) {
      case 'error':
        this.toastrService.error(text, undefined, {
          toastClass: ' toastr-wrapper ngx-toastr bg-danger',
          enableHtml: true,
        });
        break;
      case 'success':
        this.toastrService.success(text, undefined, {
          toastClass: ' toastr-wrapper ngx-toastr bg-success',
        });
        break;
      case 'info':
        this.toastrService.info(text, undefined, {
          toastClass: ' toastr-wrapper ngx-toastr bg-info',
        });
        break;
      case 'warning':
        this.toastrService.warning(text, undefined, {
          toastClass: ' toastr-wrapper ngx-toastr bg-warning',
          enableHtml: true,
        });
        break;
    }
  }

  // message popup
  messagePopup(config: IDialog): Observable<boolean> {
    const modalRef = this.modalService.show(ConfirmationComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'modal-wrapper',
      animated: true,
      initialState: { config },
    });
    return modalRef.content?.onClose as Observable<boolean>;
  }
}
